import { Tooltip, Typography } from "antd"
import { useTranslation } from "react-i18next"

const { Text } = Typography

// A stored channel value as it arrived, case and spaces kept (DAA-4-14); a long one is cut with an
// ellipsis. A value with spaces at its ends, or of spaces only, is quoted so those spaces can be seen;
// white-space: pre keeps HTML from collapsing them. The empty value reads "(empty)" and explains
// itself on hover (DAA-4-17).
const ChannelValue = ({ value }) => {
  const { t } = useTranslation()

  if (!value) {
    return (
      <Tooltip title={t("Channel not sent, or the value was longer than 64 characters")}>
        <Text type="secondary">{t("(empty)")}</Text>
      </Tooltip>
    )
  }

  const shown = value.trim() === value ? value : `"${value}"`

  return (
    <Text ellipsis={{ tooltip: shown }} style={{ whiteSpace: "pre" }}>
      {shown}
    </Text>
  )
}

export default ChannelValue
